import { versionData } from '../../../version/git-version'
import { Environment } from './../../app/models/envarioment'


export const DevDev: Environment = {
  id:'3',
  apiURLStage: 'https://gdapi-dev.doneit.co.ao/stage/api/v2/',
  apiURL: 'https://gdapi-dev.doneit.co.ao/jwt/api/',
  apiPCURL: 'https://gdapi-dev.doneit.co.ao/api/',
  logoLabel: 'Presidente da República',
  despachoLabel: 'Presidenciais',
  despachoLabel2: 'Despachos Presidênciais',
  production: false,
  domain: 'gabinetedigital.local',
  defaultuser: 'dlima@gabinetedigital.local',
  defaultuserpwd: 'tabteste@006',
  chatOffline: true,
  presidential: true,
  version: versionData,
  agendaPR: 'Agenda do PR',
  agendaVP: 'Agenda do MD',
  PR: 'PR',
  VP: '',
  dispatchPR: 'Despachos Presidênciais',
  sentryUrl: 'https://9920cc36f1d740b987426ee8d80cf588@o4504340905525248.ingest.sentry.io/4504340946419712',
  storageProduction: false,
  rejectUnauthorized: "true",
  fileHub: 'https://gdcmapi-dev.dyndns.info/FileHub'
};
